import { ErrorCodes } from '@nosinovacao/nosid-mfe-common';
import { AxiosError } from 'axios';

export function getErrorCode(err: unknown): ErrorCodes {
  let errorCode = ErrorCodes.UnknownError;
  const errorObj = err instanceof AxiosError ? err.response?.data : err;
  if (typeof errorObj === 'object' && errorObj !== null && 'ErrorCode' in errorObj) {
    errorCode = (errorObj.ErrorCode as ErrorCodes | null) ?? ErrorCodes.UnknownError;
  }
  return errorCode;
}
